import jsPDF from "jspdf";

export const exportRFQPDF = (request) => {
  const doc = new jsPDF();
  let y = 20;

  // Title
  doc.setFontSize(18);
  const displayType = request.type === "boq" ? "PO" : (request.type || "Form");
  doc.text(`ONIMS ${displayType} Document`, 14, y);
  y += 15;

  doc.setFontSize(12);

  // Helper: format labels same way as modal
  const formatLabel = (key) => {
    const overrides = {
      rfqTitle: "RFQ Title",
      referenceNumber: "Reference Number",
      buyerContact: "Buyer Contact",
      RFQId: "RFQ ID",
      issueDate: "Issue Date",
      submissionDeadline: "Submission Deadline",
      projectName: "Project Name",
      notes: "Notes",
      status: "Status",
    };
    if (overrides[key]) return overrides[key];
    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Exclude keys that are handled separately
  const excludeKeys = [
    "lineItems",
    "items",
    "boqItems",
    "files",
    "__v",
    "createdAt",
    "updatedAt",
    "_id",
  ];

  // Render details
  Object.keys(request)
    .filter((key) => !excludeKeys.includes(key))
    .forEach((key) => {
      let value = request[key];

      if (key.toLowerCase().includes("date") && value) {
        value = new Date(value).toLocaleDateString();
      }

      if (Array.isArray(value)) {
        value = value.join(", ");
      }

      if (typeof value === "object" && value !== null) {
        value = JSON.stringify(value);
      }

      doc.text(`${formatLabel(key)}: ${value || "-"}`, 14, y);
      y += 10;
    });

  // Items Table (RFQs / BOQs)
  const items = request.lineItems || request.items || request.boqItems || [];
  if (items.length > 0) {
    y += 10;
    doc.setFontSize(14);
    doc.text("Items:", 14, y);
    y += 10;

    doc.setFontSize(10);
    items.forEach((item, index) => {
      const row = `${index + 1}. ${Object.entries(item)
        .map(([k, v]) => `${formatLabel(k)}: ${v}`)
        .join(" | ")}`;
      doc.text(row, 14, y);
      y += 8;
    });
  }

  // Notes
  if (request.notes) {
    y += 10;
    doc.setFontSize(12);
    doc.text("Notes:", 14, y);
    y += 10;

    const splitNotes = doc.splitTextToSize(request.notes, 180);
    doc.text(splitNotes, 14, y);
    y += splitNotes.length * 7;
  }

  // Attached Files
  if (request.files && request.files.length > 0) {
    y += 10;
    doc.setFontSize(12);
    doc.text("Attached Files:", 14, y);
    y += 10;

    request.files.forEach((file, idx) => {
      doc.text(`${idx + 1}. ${file.split("/").pop()}`, 20, y);
      y += 8;
    });
  }

  // Save PDF
  doc.save(`${(request.type === "boq" ? "PO" : request.type) || "Form"}-${request._id}.pdf`);
};
